<template>
  <div class="layout-auth">
    <n-loader :loading="$var('load')" />
    <div class="auth-bg"></div>
    <div class="logo-place">
      <div class="wrap">
        <div v-if="show" class="logo">
          <div class="mac-logo-img">
            <img :src="imgAuthLogo" alt="">
            <h1>Вот, что я люблю!</h1>
          </div>
        </div>
        <div v-if="!show" class="login-form">
          <div class="login-container">
            <div class="login-header">
              <h2>Вход</h2>
            </div>
            <div class="memo">
              <p>Добро пожаловать! Для того, чтобы продолжить работу с приложением, введите ИИН и пароль</p>
            </div>
            <n-form @submit="submit">
              <n-items>
                <n-input placeholder="ИИН" v-bind="$form.input('login')" />
                <n-input placeholder="Пароль" type="password" v-bind="$form.input('password')" />
                <n-button type="submit">Войти</n-button>
              </n-items>
            </n-form>
          </div>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import imgAuthBg from 'assets/auth/auth-backgound.png'
import imgAuthLogo from 'assets/auth/auth-logo-m.png'

export default {
  name: 'LayoutAuth',
  data() {
    return {
      imgAuthBg,
      imgAuthLogo,
      show: true,
    }
  },
  created() {
    this.$form.init({
      login: '',
      password: '',
    })
    this.$form.rules({
      login: [ 'required', ],
      password: [ 'required', ],
    })
    $app.auth.needAuth(false)
    setTimeout(this.showForm, 2000)
  },
  methods: {
    submit() {
      if (this.$form.check()) {
        this.$var('load', true)
        $api.auth.login(this.$form.get()).with('resultCount').with('resultedCount').then((response) => {
          const lData = response.data.content
          if (lData.user.isAdmin) {
            $app.auth.login(lData.user, lData.token, lData.grants)
            this.$router.push({ name: 'kln-info', })
          } else {
            $app.ui.notify('Вы не имеете доступ к этому приложению', 'danger')
          }
        }).finally(() => {
          this.$var('load', false)
        })
      }
    },
    showForm() {
      this.show = false
    },
  },
}
</script>

<style lang="scss" scoped>
  .layout-auth {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    overflow: hidden;
    position: relative;

    .wrap{
      position: relative;
    }

    .logo-place{
      .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;

        .mac-logo-img{
          text-align: center;
          img {
            width: 384px;
            height: 384px;
          }
          h1 {
            font-size: 32px;
            color: #fbd714;
            font-weight: bold;
            margin: 0;
            padding: 20px 0 0 0;
          }
        }
      }

      .login-form {
        background: #ffffff;
        width: 335px;
        margin: 0 auto;
        .login-container{
          padding: 32px 20px 32px 20px;
          text-align: center;

          .login-header{
            h2 {
              position: relative;
              font-size: 17px;
              font-weight: bold;
              margin: 0;
              padding: 0;

              &::after{
                content: '';
                position: absolute;
                height: 2px;
                background: var(--secondary);
                left: 30%;
                right: 30%;
                bottom: -10px;
              }
            }
          }
          .memo {
            p {
              text-align: center;
              height: 84px;
            }
          }
          .login-input{
            height: 68px;
            border: none;
            border-bottom: 1px solid #E9E9EC;
          }
        }
      }
    }
  }

  .auth-bg{
    position: absolute;
    height: 982px;
    left: 0;
    right: 0;
    top: 50%;
    width: 100%;
    background: #1b4932;
    transform: skewY(30deg) translate(0, -50%);
  }
</style>
